/* istanbul ignore file */

import { Injectable } from '@angular/core';

@Injectable()
export class MockClientSettingsService {
  public getServiceAddress() {
    return '';
  }

  public getDomainAddress() {
    return '';
  }
} /* istanbul ignore next */
